$(document).ready(function() {
//3秒後に実行
setTimeout(function(){
    $(".l-header__fix-text").css("opacity","1");
},2000);
//3秒後に実行
setTimeout(function(){
    $(".l-header__fix-text").css("opacity","0");
},5000);
	$('.l-header__btn').hover(
		function() {
			$(".l-header__fix-text").css("opacity","1");
		},
		function() {
			$(".l-header__fix-text").css("opacity","0");
		}
	);	
});
